// extracted by mini-css-extract-plugin
export default {"skeleton":"skeleton__skeleton","skeletonTitle":"skeleton__skeletonTitle"};